import dynamic from 'next/dynamic';

export interface SeriesData {
  name: string;
  data: Array<any>;
}

export const createSeries = (title: string, data: Array<any>): SeriesData => ({
  name: title,
  data,
});

export const AreaChart = ({
  labels,
  data,
  title,
}: {
  labels: Array<string>;
  title: string;
  data: SeriesData[];
  width?: number;
  height?: number;
}) => {
  const Chart = dynamic(() => import('react-apexcharts'), {ssr: false});

  return (
    <>
      {typeof window !== 'undefined' && data && (
        <Chart
          width={'100%'}
          height={'100%'}
          options={{
            chart: {
              type: 'area',
              zoom: {
                enabled: false,
              },
            },
            colors: ['#2b53e1'],
            fill: {
              type: 'solid',
              colors: ['transparent'],
            },
            grid: {
              show: true,
              borderColor: '#212121',
              strokeDashArray: 0,
              position: 'back',
              xaxis: {
                lines: {
                  show: false,
                },
              },
              yaxis: {
                lines: {
                  show: true,
                },
              },
              row: {
                colors: undefined,
                opacity: 0.5,
              },
              column: {
                colors: undefined,
                opacity: 0.5,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
            },
            labels,
            subtitle: {
              text: title,
              align: 'left',
            },
            xaxis: {
              type: 'datetime',
            },
            yaxis: {
              opposite: true,
            },
            legend: {
              horizontalAlign: 'left',
            },
            markers: {
              size: 5,
              colors: ['#222222'],
              strokeColors: '#2b53e1',
              strokeWidth: 2,
            },
            tooltip: {
              theme: 'dark',
            },
          }}
          type={'area'}
          series={data}
        />
      )}
    </>
  );
};
